import api from "./base"

export async function listStats() {
    const response = await api.get(`/metrics/`)
    return response
}